module.exports = __webpack_public_path__ + "static/media/visa.4e13e377.png";